import PropTypes from "prop-types";

export const programaProp = {
  programaId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};
